import { Box, CssBaseline } from "@mui/material";
import { FC, ReactNode } from "react";

import { Appbar } from "./Appbar";
import { MainContainer } from "./styledComponents";

import { Toolbar } from "./Toolbar";

type Props = {
  borderBottom?: boolean;
  children: ReactNode;
  header: string;
  isMobile: boolean;
  isLargeScreen: boolean;
  onOpenMenu: () => void;
  isOpenedMenu: boolean;
};

export const Main: FC<Props> = ({
  children,
  isMobile,
  isLargeScreen,
  onOpenMenu,
  isOpenedMenu,
}) => {
  return (
    <Box display="flex" sx={{ background: "#E8E8E8", width: "100%" }}>
      <CssBaseline />
      <MainContainer>
        <Appbar
          isMobile={isMobile}
          isLargeScreen={isLargeScreen}
          onOpenMenu={onOpenMenu}
          isOpenedMenu={isOpenedMenu}
        />
        <Box
          sx={{
            background: "#E8E8E8",
            width: "100%",
            paddingTop: isMobile && isOpenedMenu ? "330px" : "166px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              paddingLeft: {
                xs: "0px",
                sm: "40px",
              },
              paddingRight: {
                xs: "0px",
                sm: "40px",
              },
            }}
          >
            {children}
          </Box>
          <Toolbar />
        </Box>
      </MainContainer>
    </Box>
  );
};
